import EventEmitter from './EventEmitter.js'

export default class Time extends EventEmitter {
  constructor () {
    super()

    // Setup
    this.start = Date.now()
    this.current = this.start
    this.elapsed = 0
    this.delta = 16

    window.requestAnimationFrame(() => {
      this.tick()
    })
  }

  tick () {
    const currentTime = Date.now()
    this.delta = currentTime - this.current
    this.current = currentTime
    this.elapsed = this.current - this.start

    this.trigger('tick')

    window.requestAnimationFrame(() => {
      this.tick()
    })
  }

  setGUI () {
    this.debugFolder = this.debug.ui.addFolder('Time')
    this.debugFolder.add(this, 'time').min(0).max(1000).step(1).onFinishChange(() => { this.material.uniforms.time.value = this.time })
  }
}
